/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ClientApplicationMessageHandler
 * @extends com.inq.flash.messagingframework.AbstractMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler = function(messageType) {
	com.inq.flash.messagingframework.AbstractMessageHandler.call(this,messageType);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler'] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ClientApplicationMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.__super__ = com.inq.flash.messagingframework.AbstractMessageHandler;
for(var k in com.inq.flash.messagingframework.AbstractMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k] = com.inq.flash.messagingframework.AbstractMessageHandler.prototype[k];

/**
 * getController
 *
 * $type TFun([],TInst(com.inq.flash.client.control.ApplicationController,[]))
 * public function getController():ApplicationController
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @return {com.inq.flash.client.control.ApplicationController}
 */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.getController = function() {
	return this.controller;
};


/**
 * setController
 *
 * $type TFun([{ name => controller, t => TInst(com.inq.flash.client.control.ApplicationController,[]), opt => false }],TEnum(Void,[]))
 * public function setController(controller:ApplicationController):Void
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @param {com.inq.flash.client.control.ApplicationController}  controller 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.setController = function(controller) {
	this.controller = controller;
};

/**
 * Agent config should be set only if agent id is exist.
 * And if there isn't replay, it means that this message wasn't processed before.
 * Or if it is last assigned message and agent id is not same in message and in rulesgen,
 * if agent ids aren't same it means that this message wasn't process,
 * for example because of page reload,
 * and agent id should be update to id of last assigned agent.
 *
 * @param {string} agentID - agent id
 * @param {com.inq.flash.messagingframework.Message} message - message
 * @param {boolean=} cobrowseEnabled - cobrowse enabled flag
 */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.setAgent = function (agentID, message, cobrowseEnabled) {
	/** @type {string} */
	var currentAgentID = com.inq.flash.client.control.FlashPeer.getAgentID();
	/** @type {boolean} */
	var isLastAssignedMessage = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_LAST_AGENT_ASSIGNED_MESSAGE);
	/** @type {boolean} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) === "1";
	/** @type {boolean} */
	var _cobrowseEnabled;

	if (typeof cobrowseEnabled !== "boolean") {
		_cobrowseEnabled = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_ENABLED);
	} else {
		_cobrowseEnabled = cobrowseEnabled;
	}

	if (agentID && (!replay || (isLastAssignedMessage && agentID !== currentAgentID))) {
		this.getController().setAgentConfig(
			agentID,
			com.inq.utils.EventDataUtils.fromMessage(message),
			_cobrowseEnabled,
			message.getProperty(com.inq.flash.client.data.MessageFields.KEY_BUSINESS_UNIT_ID),
			message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_GROUP_ID)
		);
	}
};

com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.handleCustomEventAttributes = function(chatText) {
	var isCustomEvent = chatText && chatText.indexOf("data-nuance-event") != -1;
	if (isCustomEvent) {
		return this.processCustomEventAttributes(chatText);
	}
	return chatText;
};

com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.processCustomEventAttributes = function(chatText) {
	const eventAttributeRegEx = /<a.*?data-nuance-event=['"](.*?)['"].*?>/g;
	var that = this;
	return chatText.replace(eventAttributeRegEx, function(match, eventName) {
		return that.injectCustomEventClickHandler(match, eventName);
	});	
};

com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.injectCustomEventClickHandler = function(match, eventName) {
	const eventPayloadAttributeRegEx = /data-nuance-event-payload=["](.*?)["][>\s]/g;
	var payload = eventPayloadAttributeRegEx.exec(match);	
	return match.replace(/>$/," onclick=\"inqFrame.Inq.FlashPeer.fireCustomEvt('"+eventName+"',"+(payload ? payload[1] : null)+"); return false;\">");
}

com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.getFilteredText = function(text) {
	if (text && text.indexOf("data-nuance-event") != -1) {
		text = text.replace(/data-nuance-event-payload=\"{(.*?)}\"/, function(match,data) {
			return "data-nuance-event-payload=\"{" + data.replace(/\"|\\\"/g,"\'") + "}\""
		});
	}

	if (com.inq.flash.client.control.FlashPeer.getRemoveJSInMessages()) {

		//Allow only certain safe CSS in the style attribute
		const filterCSSOptions = {
			whiteList: Object.assign(filterCSS.getDefaultWhiteList(), {
				"overflow-x": true
			})
		};
		const filterXSSOptions = {
			whiteList: Object.assign(filterXSS.getDefaultWhiteList(), {
				style: [],
				table: ["cellspacing", "cellpadding", "width", "border", "align"],
			}),
			//<-- css:false => Alone not safe BUT IS safe if we 
			// filterCSS the style tag contents via onTagAttr
			//https://github.com/leizongmin/js-xss/issues/72#issuecomment-359693586
			css: false,
			onTagAttr: (tag, name, value, isWhiteAttr) => {
				if (name === 'style') {
					return `${name}="${filterCSS(value, filterCSSOptions )}"`;
				}

				// Allow any attribute that starts with aria for any tag
				if (name.startsWith('aria')) {
					return `${name}="${this.xssModule.escapeAttrValue(value)}"`;
				}
			},
			//<-- alone not safe
			//Global tag attributes allowed
			onIgnoreTagAttr: function (tag, name, value, isWhiteAttr) {
				if (['class', 'title', 'id', 'cobshoff', 'coboff'].indexOf(name) !== -1 || 
					(name.substr(0, 5) === "data-")) {
					return `${name}="${value}"`;
				}
			}
		};

		//Default white list + our custom tags
		text = this.xssModule(text, filterXSSOptions);
	}
	return text;
 };

/** @private @type {com.inq.flash.client.control.ApplicationController} */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.controller = null;
/** @type {com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler} */
com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
